export enum OrderQuoteSettingsAPI {
  LIST = "/orderAndQuoteSettingsList", // GET
  UPDATE = "/updateOrderAndQuote", // PUT
  SAVE = "/saveEmail", // POST
  EDIT = "/editEmail", // PUT
  DELETE = "/deleteOrderAndQuoteEntry", // DELETE
}
